import React from 'react';
import { Folder, FolderOpen, Image } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface FolderCardProps {
  folder: {
    id: string;
    name: string;
    image_count?: number;
  };
  imageCount: number;
  previewImage?: string;
  onClick: () => void;
}

export const FolderCard: React.FC<FolderCardProps> = ({
  folder,
  imageCount,
  previewImage,
  onClick,
}) => {
  return (
    <Card
      className="cursor-pointer hover:shadow-lg transition-all duration-200 hover:scale-105 group"
      onClick={onClick}
    >
      <CardContent className="p-4">
        <div className="aspect-square relative mb-3 flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg overflow-hidden">
          {previewImage ? (
            <>
              <img
                src={previewImage}
                alt="Folder preview"
                className="w-full h-full object-cover opacity-30"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <FolderOpen className="w-12 h-12 text-blue-600 group-hover:text-blue-700 transition-colors" />
              </div>
            </>
          ) : (
            <Folder className="w-12 h-12 text-blue-600 group-hover:text-blue-700 transition-colors" />
          )}

          {imageCount === 0 && (
            <div className="absolute bottom-2 right-2">
              <div className="bg-gray-100 rounded-full p-1">
                <Image className="w-3 h-3 text-gray-400" />
              </div>
            </div>
          )}
        </div>

        <div className="space-y-2">
          <h4 className="font-medium text-sm text-gray-900 truncate" title={folder.name}>
            {folder.name}
          </h4>

          <div className="flex items-center justify-between">
            <Badge variant="secondary" className="text-xs">
              {imageCount} {imageCount === 1 ? 'image' : 'images'}
            </Badge>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
